var map = {
	"./fire@2x.png": "f4d6",
	"./fire_card@2x.png": "4752",
	"./ice@2x.png": "320f",
	"./ice_card@2x.png": "151d",
	"./rock@2x.png": "a8ec",
	"./rock_card@2x.png": "4a2d",
	"./thunder@2x.png": "f104",
	"./thunder_card@2x.png": "504b",
	"./wind@2x.png": "ec70",
	"./wind_card@2x.png": "0abd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16df";